import React from 'react'
import Link from 'gatsby-link'

const BooksSection = ({ id, books, darkBg }) => (
  <section id={id} className={`main special ${darkBg ? 'style3' : 'style1'}`}>
    <div className="grid-wrapper">
      <div className="col-12">
        <header className="major">
          <h2>Books</h2>
        </header>
      </div>

      {books.map((book, key) => {
        return (
          <div className="col-4" key={key}>
            <span className="image fit">
              <a href={book.link} target="_blank">
                <img src={book.image.src} alt={book.image.alt} />
              </a>
            </span>
            <h3>
              <a href={book.link} target="_blank">{book.title}</a>
            </h3>
            <p style={{ textAlign: 'left' }}>{book.description}</p>
          </div>
        )
      })}
    </div>
  </section>
)

export default BooksSection



// WEBPACK FOOTER //
// ./src/components/BooksSection.js